import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

myListsDetailsOptionsStyles.paginationContainer = {
    ...myListsDetailsOptionsStyles.paginationContainer,

    gap: 0,

    css: css`
        margin: 0;

        @media print {
            display: none;
        }
    `,
};

myListsDetailsOptionsStyles.pagination = {
    ...myListsDetailsOptionsStyles.pagination,

    cssOverrides: {
        pagination: css`
            && {
                margin: 0;
            }

            @media print {
                display: none;
            }
        `,

        perPageSelect: css`
            ${mediaQueriesBP.minMD} {
                width: auto;
            }

            ${mediaQueriesBP.maxMD} {
                && {
                    margin-bottom: 12px;
                }
            }
        `,

        linkList: css`
            ${mediaQueriesBP.minMD} {
                width: auto;
            }
        `,
    },
};
